module.exports = __webpack_public_path__ + "img/shared1.83cd78e5.png";